import React from 'react';
import { ReviewTemplateProps } from '../types';
import StarRating from '../../components/StarRating';
import { formatRecommendationDisplay, getRatingNumber } from '../../utils/formatters';
import bgTemplate1 from '../../../assets/shareReview/template1/bgTemplate1.png';
import SourceLogo from '../components/SourceLogo';
import quote from '../../../assets/shareReview/template1/quote.svg';

const ShareReviewTemplate1: React.FC<ReviewTemplateProps> = ({
    reviewerName,
    reviewText,
    rating,
    network,
    color = '#eab308',
    logo,
    showLogo,
    showSource,
}) => {
    const numericRating = getRatingNumber(rating);
    const isFacebookRecommendation =
        network === 'facebook' && (rating === 'positive' || rating === 'negative');

    return (
        <div
            className="w-[1080px] h-[1080px] p-24 relative rounded-xl inline-flex flex-col justify-start items-center gap-10 overflow-hidden"
            style={{ backgroundColor: color }}
        >
            {showLogo && logo && (
                <div className="z-[1000] pb-[10px] px-[40px] w-[415px] h-[135px] bottom-[98px] left-[64px] absolute flex justify-center">
                    <img src={logo} alt="Logo" className="w-auto h-full" crossOrigin="anonymous" />
                </div>
            )}

            <img className="absolute w-[956px] h-[888px]" src={bgTemplate1} alt="" />

            <div className="w-[888px] left-[96px] top-[154px] absolute flex flex-col justify-start items-start gap-10">
                <div className="self-stretch inline-flex justify-between items-start">
                    <img src={quote} alt="quote" />
                    {showSource && <SourceLogo network={network} template="template1" />}
                </div>

                <div className="self-stretch text-left text-white text-5xl font-semibold font-['Montserrat'] leading-[52.80px]">
                    {reviewText}
                </div>

                {isFacebookRecommendation ? (
                    <div className="self-stretch inline-flex flex-col justify-start items-start gap-2.5">
                        <div className="self-stretch text-left text-white text-[40px] font-semibold font-['Montserrat'] leading-[42px]">
                            {reviewerName}
                        </div>
                        <div>{formatRecommendationDisplay(rating, 'template1')}</div>
                    </div>
                ) : (
                    <div className="self-stretch text-left text-white text-[40px] font-semibold font-['Montserrat'] leading-[42px]">
                        {reviewerName}
                    </div>
                )}
            </div>

            {!isFacebookRecommendation && (
                <div className="absolute bottom-[120px] right-[127px]">
                    <StarRating rating={numericRating} iconSize="h-[80px] w-[80px]" />
                </div>
            )}
        </div>
    );
};

export default ShareReviewTemplate1;
